import React, { Component } from "react";
import { Row, Col } from "antd";
import RcuControlNoChild from "../../components/RcuControls/RcuControlNoChild";
import RcuControlWithChild from "../../components/RcuControls/RcuControlWithChild";

class Rcu2702 extends Component {
  mainControlRender = () => {
    const { rcuControlStore } = this.props;
    const { makeUpRoom, dnd } = rcuControlStore.deviceControl;
    const { master, masterShowDetail, masterOff } = rcuControlStore.lampControl;

    return (
      <React.Fragment>
        <RcuControlNoChild Title="make.up.room" Icon="MakeUpRoomWhite.svg" isOn={makeUpRoom} onClick={() => rcuControlStore.setMakeUpRoom()} ShowSwitchText={true} />
        <RcuControlNoChild Title="do.not.disturb" Icon="DndWhite.svg" isOn={dnd} onClick={() => rcuControlStore.setDnd()} ShowSwitchText={true} />
        <RcuControlWithChild Title="master" Icon="LampOn.png" Device={master} ShowDetail={masterShowDetail} Handlers={{ turnAllOff: () => rcuControlStore.setMasterAllOff(), bright: () => rcuControlStore.setMasterBright(), soft: () => rcuControlStore.setMasterSoft(), setShowDetail: () => rcuControlStore.setmasterShowDetail() }} />
        <RcuControlNoChild Title="master.off" Icon="LampOn.png" isOn={masterOff} onClick={() => rcuControlStore.setMasterOff()} ShowSwitchText={true} />
      </React.Fragment>
    );
  };

  bedroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { bedroom, bedroomShowDetail, table } = rcuControlStore.lampControl;
    const { open: sheerOpen, close: sheerClose } = rcuControlStore.bedRoomSheerControl;
    const { open: blindOpen, close: blindClose } = rcuControlStore.bedRoomBlindControl;
    const { bedroomAc } = rcuControlStore;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}><div className="div-rcu-category">Master Bedroom</div></Col>
        <RcuControlWithChild ColSpan={24} Title="bedroom.m" Icon="LampOn.png" Device={bedroom} ShowDetail={bedroomShowDetail} Handlers={{ turnAllOff: () => rcuControlStore.setBedroomAllOff(), bright: () => rcuControlStore.setBedroomBright(), soft: () => rcuControlStore.setBedroomSoft(), night: () => rcuControlStore.setBedroomNight(), readingleft: () => rcuControlStore.setBedroomReadingLeft(), readingright: () => rcuControlStore.setBedroomReadingRight(), setShowDetail: () => rcuControlStore.setbedroomShowDetail() }} />
        <RcuControlNoChild Title="ac" Icon="AC.svg" isOn={bedroomAc} onClick={() => rcuControlStore.setBedroomAc()} ShowSwitchText={true} />
        <RcuControlNoChild Title="bedroom.m.table" Icon="LampOn.png" isOn={table} onClick={() => rcuControlStore.setTable()} />
        <RcuControlNoChild Title="blind.up" Icon="BlindUp.png" isOn={blindOpen} onClick={() => rcuControlStore.setBedRoomBlindOpen()} />
        <RcuControlNoChild Title="blind.down" Icon="BlindDown.png" isOn={blindClose} onClick={() => rcuControlStore.setBedRoomBlindClose()} />
        <RcuControlNoChild Title="sheer.open" Icon="BlindUp.png" isOn={sheerOpen} onClick={() => rcuControlStore.setBedRoomSheerOpen()} />
        <RcuControlNoChild Title="sheer.close" Icon="BlindDown.png" isOn={sheerClose} onClick={() => rcuControlStore.setBedRoomSheerClose()} />
      </React.Fragment>
    );
  };

  bathroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { bathroom, bathroomShowDetail } = rcuControlStore.lampControl;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}><div className="div-rcu-category">Master Bathroom</div></Col>
        <RcuControlWithChild ColSpan={24} Title="bathroom.m" Icon="LampOn.png" Device={bathroom} ShowDetail={bathroomShowDetail} Handlers={{ turnAllOff: () => rcuControlStore.setBathroomAllOff(), bright: () => rcuControlStore.setBathroomBright(), soft: () => rcuControlStore.setBathroomSoft(), setShowDetail: () => rcuControlStore.setbathroomShowDetail() }} />
      </React.Fragment>
    );
  };

  balconyControlRender = () => {
    const { rcuControlStore } = this.props;
    const { balcony } = rcuControlStore.lampControl;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}><div className="div-rcu-category">Balcony</div></Col>
        <RcuControlNoChild Title="balcony" Icon="LampOn.png" isOn={balcony} onClick={() => rcuControlStore.setBalcony()} />
      </React.Fragment>
    );
  };

  livingroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { livingroom, livingroomShowDetail, pantry, diningroom, diningroomShowDetail } = rcuControlStore.lampControl;
    const { open: sheerOpen, close: sheerClose } = rcuControlStore.livingRoomSheerControl;
    const { blindUp, blindDown } = rcuControlStore.livingRoomControl;
    const { livingroomAc } = rcuControlStore;

    return (
      <>
        <Col span={24} style={{ paddingLeft: 8 }}><div className="div-rcu-category">Living Room</div></Col>
        <RcuControlWithChild ColSpan={24} Title="livingroom" Icon="LampOn.png" Device={livingroom} ShowDetail={livingroomShowDetail} Handlers={{ turnAllOff: () => rcuControlStore.setLivingroomAllOff(), bright: () => rcuControlStore.setLivingroomBright(), soft: () => rcuControlStore.setLivingroomSoft(), setShowDetail: () => rcuControlStore.setlivingroomShowDetail() }} />
        <RcuControlNoChild Title="ac" Icon="AC.svg" isOn={livingroomAc} onClick={() => rcuControlStore.setLivingroomAc()} ShowSwitchText={true} />
        <RcuControlWithChild Title="diningroom" Icon="LampOn.png" Device={diningroom} ShowDetail={diningroomShowDetail} Handlers={{ turnAllOff: () => rcuControlStore.setDiningroomAllOff(), bright: () => rcuControlStore.setDiningroomBright(), soft: () => rcuControlStore.setDiningroomSoft(), setShowDetail: () => rcuControlStore.setdiningroomShowDetail() }} />
        <RcuControlNoChild Title="pantry" Icon="LampOn.png" isOn={pantry} onClick={() => rcuControlStore.setPantry()} />
        <Col span={12} className="col-rcu-menu-wrap" />
        <RcuControlNoChild Title="blind.up" Icon="BlindUp.png" isOn={blindUp} onClick={() => rcuControlStore.setLivingRoomBlindUp()} />
        <RcuControlNoChild Title="blind.down" Icon="BlindDown.png" isOn={blindDown} onClick={() => rcuControlStore.setLivingRoomBlindDown()} />
        <RcuControlNoChild Title="sheer.open" Icon="BlindUp.png" isOn={sheerOpen} onClick={() => rcuControlStore.setLivingRoomSheerOpen()} />
        <RcuControlNoChild Title="sheer.close" Icon="BlindDown.png" isOn={sheerClose} onClick={() => rcuControlStore.setLivingRoomSheerClose()} />
      </>
    );
  };

  bedroom2ControlRender = () => {
    const { rcuControlStore } = this.props;
    const { bedroom2, bedroom2ShowDetail, bedroom2Table, bedroom2Closet } = rcuControlStore.lampControl;
    const { bedroom2Ac } = rcuControlStore;
    const { up: sheerUp, down: sheerDown } = rcuControlStore.bedRoom2SheerControl;
    const { up: blindUp, down: blindDown } = rcuControlStore.bedRoom2BlindControl;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}><div className="div-rcu-category">Bedroom 2</div></Col>
        <RcuControlWithChild ColSpan={24} Title="bedroom.2" Icon="LampOn.png" Device={bedroom2} ShowDetail={bedroom2ShowDetail} Handlers={{ turnAllOff: () => rcuControlStore.setBedroom2AllOff(), bright: () => rcuControlStore.setBedroom2Bright(), soft: () => rcuControlStore.setBedroom2Soft(), night: () => rcuControlStore.setBedroom2Night(), reading: () => rcuControlStore.setBedroom2Reading(), reading2l: () => rcuControlStore.setBedroom2Reading2l(), setShowDetail: () => rcuControlStore.setbedroom2ShowDetail() }} />
        <RcuControlNoChild Title="ac" Icon="AC.svg" isOn={bedroom2Ac} onClick={() => rcuControlStore.setBedroom2Ac()} ShowSwitchText={true} />
        <RcuControlNoChild Title="closet" Icon="LampOn.png" isOn={bedroom2Closet} onClick={() => rcuControlStore.setBedroom2Closet()} />
        <RcuControlNoChild Title="table" Icon="LampOn.png" isOn={bedroom2Table} onClick={() => rcuControlStore.setBedroom2Table()} />
        <Col span={12} className="col-rcu-menu-wrap" />
        <RcuControlNoChild Title="blind.up" Icon="BlindUp.png" isOn={blindUp} onClick={() => rcuControlStore.setBedRoom2BlindUp()} />
        <RcuControlNoChild Title="blind.down" Icon="BlindDown.png" isOn={blindDown} onClick={() => rcuControlStore.setBedRoom2BlindDown()} />
        <RcuControlNoChild Title="sheer.open" Icon="BlindUp.png" isOn={sheerUp} onClick={() => rcuControlStore.setBedRoom2SheerUp()} />
        <RcuControlNoChild Title="sheer.close" Icon="BlindDown.png" isOn={sheerDown} onClick={() => rcuControlStore.setBedRoom2SheerDown()} />
      </React.Fragment>
    );
  };

  bathroom2ControlRender = () => {
    const { rcuControlStore } = this.props;
    const { bathroom2, bathroom2ShowDetail } = rcuControlStore.lampControl;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}><div className="div-rcu-category">Bathroom 2</div></Col>
        <RcuControlWithChild ColSpan={24} Title="bathroom.2" Icon="LampOn.png" Device={bathroom2} ShowDetail={bathroom2ShowDetail} Handlers={{ turnAllOff: () => rcuControlStore.setBathroom2AllOff(), bright: () => rcuControlStore.setBathroom2Bright(), soft: () => rcuControlStore.setBathroom2Soft(), setShowDetail: () => rcuControlStore.setbathroom2ShowDetail() }} />
      </React.Fragment>
    );
  };

  render() {
    return (
      <>
        <Row className="row-rcu-menu">{this.mainControlRender()}</Row>
        <Row className="row-rcu-menu">{this.bedroom2ControlRender()}</Row>
        <Row className="row-rcu-menu">{this.bathroom2ControlRender()}</Row>
        <Row className="row-rcu-menu">{this.livingroomControlRender()}</Row>
      </>
    );
  }
}

export default Rcu2702;
